module.exports = __webpack_public_path__ + "1_0_59/img/200 Kalon.6ce1bb68.jpg";